import { StyleSheet } from "react-native";

const MISANS = 'MiSans, "Inter Variable", Inter, "Microsoft YaHei", sans-serif';
const INTER = '"Inter Variable", Inter, MiSans, sans-serif';

export default StyleSheet.create({
  page: {
    flex: 1,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    minHeight: 0,
    flexDirection: "row",
    backgroundColor: "#020908",
    backgroundImage:
      "radial-gradient(circle at 66% 5%, rgba(20,91,70,.20), transparent 32%), linear-gradient(135deg,#020807 0%,#03110e 58%,#020706 100%)",
    fontFamily: MISANS,
    overflow: "hidden",
  },
  sidebar: {
    minHeight: 0,
    flexShrink: 0,
    overflow: "hidden",
    backgroundColor: "rgba(2,10,9,.96)",
    paddingHorizontal: 12,
    borderRightWidth: 1,
    borderRightColor: "rgba(215,182,93,.18)",
  },
  sidebarHeader: {
    height: 68,
    flexShrink: 0,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 8,
  },
  sidebarToggle: {
    minWidth: 40,
    minHeight: 40,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    borderRadius: 8,
  },
  sidebarToggleText: {
    fontFamily: MISANS,
    fontSize: 14,
    color: "#c8c3ba",
  },
  sidebarScroll: {
    flex: 1,
    minHeight: 0,
  },
  sidebarScrollContent: {
    paddingBottom: 18,
  },
  sidebarRecommendationSection: {
    minWidth: 0,
    width: "100%",
  },
  sidebarFilterGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  sidebarFilterChip: {
    flexBasis: "47%",
    flexGrow: 1,
    minWidth: 0,
    maxWidth: "100%",
    minHeight: 36,
    paddingHorizontal: 6,
    paddingVertical: 8,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(7,21,17,.78)",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.25)",
  },
  sidebarSearchChip: { flexBasis: "100%" },
  sidebarFilterLabel: {
    maxWidth: "100%",
    fontFamily: MISANS,
    fontSize: 12,
    fontWeight: "500",
    color: "#d5ddda",
    textAlign: "center",
  },
  sidebarFilterEmpty: {
    marginHorizontal: 13,
    fontFamily: MISANS,
    fontSize: 12,
    color: "#65706c",
  },
  brand: {
    width: 198,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 0,
  },
  brandPressed: { opacity: 0.76, transform: [{ scale: 0.98 }] },
  brandLogo: { width: 194, height: 60 },
  brandMark: {
    width: 38,
    height: 38,
    borderRadius: 11,
    borderWidth: 1,
    borderColor: "#6d5634",
  },
  brandCopy: { width: 140, alignItems: "flex-start", justifyContent: "center" },
  brandWordmark: { width: 112, height: 25 },
  brandEnglish: {
    width: 140,
    textAlign: "left",
    fontSize: 7,
    fontWeight: "700",
    color: "#a98550",
    letterSpacing: 1.05,
    marginTop: 1,
    whiteSpace: "nowrap",
  } as never,
  sidebarSection: { gap: 3 },
  sidebarItem: {
    height: 46,
    flexDirection: "row",
    alignItems: "center",
    gap: 24,
    paddingHorizontal: 13,
    borderRadius: 10,
  },
  sidebarItemActive: {
    backgroundColor: "rgba(40,201,154,.13)",
    borderWidth: 1,
    borderColor: "rgba(40,201,154,.48)",
  },
  sidebarLabel: {
    fontFamily: MISANS,
    fontSize: 16,
    fontWeight: "500",
    color: "#a9b2af",
  },
  sidebarLabelActive: { color: "#f2f5f4", fontWeight: "600" },
  divider: {
    height: 1,
    backgroundColor: "rgba(215,182,93,.14)",
    marginVertical: 12,
  },
  sectionTitle: {
    fontFamily: MISANS,
    fontSize: 14,
    fontWeight: "600",
    color: "#28c99a",
    marginHorizontal: 13,
    marginBottom: 8,
  },
  footerCopy: {
    fontFamily: MISANS,
    fontSize: 11,
    lineHeight: 18,
    color: "#65706c",
    marginHorizontal: 13,
  },
  main: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    height: "100%",
    overflow: "hidden",
    backgroundColor: "transparent",
  },
  mobileFeedEmbed: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    backgroundColor: "#050505",
    overflow: "hidden",
  },
  desktopProfileScroll: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    backgroundColor: "#090909",
  },
  desktopProfileContent: {
    width: "100%",
    padding: 24,
    paddingBottom: 52,
    gap: 18,
  },
  desktopProfileHero: {
    width: "100%",
    minHeight: 176,
    paddingHorizontal: 28,
    paddingVertical: 26,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "#4d3b24",
    backgroundColor: "#15130f",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 24,
  },
  desktopProfileIdentity: {
    minWidth: 240,
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 20,
  },
  desktopProfileAvatar: {
    width: 88,
    height: 88,
    borderRadius: 44,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#322718",
    borderWidth: 2,
    borderColor: "#d7a955",
  },
  desktopProfileAvatarText: {
    color: "#fff8eb",
    fontSize: 34,
    fontWeight: "900",
  },
  desktopProfileIdentityCopy: { minWidth: 0, flex: 1 },
  desktopProfileTitleRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 10,
  },
  desktopProfileName: { color: "#f7f0e5", fontSize: 27, fontWeight: "900" },
  desktopProfileStatusBadge: {
    minHeight: 25,
    paddingHorizontal: 10,
    borderRadius: 13,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#203522",
    borderWidth: 1,
    borderColor: "#3f7448",
  },
  desktopProfileStatusText: {
    color: "#8fd39a",
    fontSize: 11,
    fontWeight: "800",
  },
  desktopProfileEmail: { marginTop: 7, color: "#b9afa1", fontSize: 14 },
  desktopProfileDescription: {
    maxWidth: 650,
    marginTop: 11,
    color: "#887f72",
    fontSize: 13,
    lineHeight: 20,
  },
  desktopProfileActions: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 10,
  },
  desktopProfileSecondaryButton: {
    height: 42,
    paddingHorizontal: 16,
    borderRadius: 21,
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    backgroundColor: "#1c1914",
    borderWidth: 1,
    borderColor: "#5a472c",
  },
  desktopProfileSecondaryButtonText: {
    color: "#e6c88f",
    fontSize: 13,
    fontWeight: "800",
  },
  desktopProfilePrimaryButton: {
    height: 42,
    paddingHorizontal: 17,
    borderRadius: 21,
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    backgroundColor: "#d7a955",
  },
  desktopProfilePrimaryButtonText: {
    color: "#17120b",
    fontSize: 13,
    fontWeight: "900",
  },
  smartPlaybackSettings: {
    width: "100%",
    padding: 22,
    borderRadius: 18,
    backgroundColor: "#0c1713",
    borderWidth: 1,
    borderColor: "#285848",
  },
  smartPlaybackSettingsHeader: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
  },
  smartPlaybackSettingsHeading: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    minWidth: 240,
    flex: 1,
  },
  smartPlaybackSettingsIcon: {
    width: 42,
    height: 42,
    borderRadius: 21,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#28c99a",
  },
  smartPlaybackSettingsCopy: { flex: 1, minWidth: 0 },
  smartPlaybackSettingsTitle: {
    color: "#edf8f3",
    fontSize: 20,
    fontWeight: "900",
  },
  smartPlaybackSettingsSubtitle: {
    marginTop: 4,
    color: "#769187",
    fontSize: 12,
  },
  smartPlaybackSourceBadge: {
    minHeight: 30,
    paddingHorizontal: 12,
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#242722",
    borderWidth: 1,
    borderColor: "#5e645d",
  },
  smartPlaybackSourceBadgeCustom: {
    backgroundColor: "#163d31",
    borderColor: "#28c99a",
  },
  smartPlaybackSourceBadgeText: {
    color: "#c7d8d1",
    fontSize: 11,
    fontWeight: "900",
  },
  smartPlaybackPresetHeader: {
    marginTop: 22,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: 12,
  },
  smartPlaybackSectionTitle: {
    color: "#e9f1ed",
    fontSize: 14,
    fontWeight: "900",
  },
  smartPlaybackSectionHint: {
    marginTop: 4,
    color: "#71877e",
    fontSize: 11,
  },
  smartPlaybackLoginButton: {
    minHeight: 34,
    paddingHorizontal: 13,
    borderRadius: 17,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#182a23",
    borderWidth: 1,
    borderColor: "#3a6c5a",
  },
  smartPlaybackLoginButtonText: {
    color: "#a9e6d3",
    fontSize: 11,
    fontWeight: "900",
  },
  smartPlaybackPresetGrid: {
    width: "100%",
    marginTop: 11,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  smartPlaybackPresetCard: {
    minWidth: 135,
    minHeight: 82,
    flexBasis: 155,
    flexGrow: 1,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 11,
    backgroundColor: "#111e19",
    borderWidth: 1,
    borderColor: "#25463a",
  },
  smartPlaybackPresetCardActive: {
    backgroundColor: "#28c99a",
    borderColor: "#67e6c0",
  },
  smartPlaybackPresetIndex: {
    color: "#4d7567",
    fontSize: 10,
    fontWeight: "900",
  },
  smartPlaybackPresetLabel: {
    marginTop: 4,
    color: "#deebe6",
    fontSize: 13,
    fontWeight: "900",
  },
  smartPlaybackPresetTextActive: { color: "#04110d" },
  smartPlaybackPresetDescription: {
    marginTop: 3,
    color: "#72867e",
    fontSize: 10,
  },
  smartPlaybackPresetDescriptionActive: { color: "#145443" },
  smartPlaybackFieldHeader: {
    marginTop: 22,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: 10,
  },
  smartPlaybackFieldGrid: {
    width: "100%",
    marginTop: 11,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  smartPlaybackFieldCard: {
    minWidth: 210,
    flexBasis: 240,
    flexGrow: 1,
    padding: 12,
    borderRadius: 10,
    backgroundColor: "#09120f",
    borderWidth: 1,
    borderColor: "#1f3a31",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  smartPlaybackFieldCopy: { flex: 1, minWidth: 0 },
  smartPlaybackFieldLabel: {
    color: "#d9e6e1",
    fontSize: 12,
    fontWeight: "900",
  },
  smartPlaybackFieldDescription: {
    marginTop: 3,
    color: "#61766e",
    fontSize: 9,
  },
  smartPlaybackStepper: {
    height: 32,
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 8,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#36594c",
    backgroundColor: "#07100d",
  },
  smartPlaybackStepButton: {
    width: 30,
    height: 32,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#14251f",
  },
  smartPlaybackValueInput: {
    width: 46,
    height: 32,
    paddingHorizontal: 3,
    paddingVertical: 0,
    color: "#f1dca9",
    fontSize: 12,
    fontWeight: "900",
    textAlign: "center",
    backgroundColor: "#07100d",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#36594c",
  },
  smartPlaybackSettingsFooter: {
    marginTop: 18,
    paddingTop: 15,
    borderTopWidth: 1,
    borderTopColor: "#203d33",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  smartPlaybackNotice: {
    flex: 1,
    minWidth: 220,
    color: "#81ab9b",
    fontSize: 11,
  },
  smartPlaybackSettingsActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  smartPlaybackResetButton: {
    height: 38,
    paddingHorizontal: 14,
    borderRadius: 19,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#17231f",
    borderWidth: 1,
    borderColor: "#3d5a50",
  },
  smartPlaybackResetButtonText: {
    color: "#b9cbc4",
    fontSize: 11,
    fontWeight: "900",
  },
  smartPlaybackSaveButton: {
    height: 38,
    paddingHorizontal: 16,
    borderRadius: 19,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 7,
    backgroundColor: "#28c99a",
  },
  smartPlaybackSaveButtonDisabled: { opacity: 0.55 },
  smartPlaybackSaveButtonText: {
    color: "#04110d",
    fontSize: 12,
    fontWeight: "900",
  },
  desktopProfileStatGrid: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
  },
  desktopProfileStatCard: {
    minWidth: 190,
    minHeight: 132,
    flexGrow: 1,
    flexBasis: 210,
    paddingHorizontal: 18,
    paddingVertical: 16,
    borderRadius: 14,
    backgroundColor: "#141414",
    borderWidth: 1,
    borderColor: "#302820",
  },
  desktopProfileStatIcon: {
    width: 34,
    height: 34,
    borderRadius: 17,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#2b2115",
  },
  desktopProfileStatLabel: {
    marginTop: 10,
    color: "#9f968a",
    fontSize: 12,
    fontWeight: "700",
  },
  desktopProfileStatValue: {
    marginTop: 4,
    color: "#f5efe5",
    fontSize: 24,
    fontWeight: "900",
  },
  desktopProfileStatHint: { marginTop: 4, color: "#746d64", fontSize: 11 },
  desktopProfileKeywords: {
    width: "100%",
    paddingHorizontal: 18,
    paddingVertical: 16,
    borderRadius: 14,
    backgroundColor: "#11110f",
    borderWidth: 1,
    borderColor: "#2c261e",
  },
  desktopProfileKeywordsTitle: {
    color: "#e6c88f",
    fontSize: 13,
    fontWeight: "900",
  },
  desktopProfileKeywordList: {
    marginTop: 11,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  desktopProfileKeyword: {
    minHeight: 32,
    paddingHorizontal: 11,
    borderRadius: 16,
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    backgroundColor: "#1e1a14",
    borderWidth: 1,
    borderColor: "#554226",
  },
  desktopProfileKeywordText: {
    color: "#d9c9ad",
    fontSize: 12,
    fontWeight: "700",
  },
  desktopProfileKeywordCount: {
    color: "#8f7650",
    fontSize: 10,
    fontWeight: "800",
  },
  desktopProfileLibraryHeader: {
    width: "100%",
    paddingTop: 6,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: 16,
  },
  desktopProfileLibraryTitle: {
    color: "#f5efe5",
    fontSize: 21,
    fontWeight: "900",
  },
  desktopProfileLibrarySubtitle: {
    marginTop: 5,
    color: "#837a6e",
    fontSize: 12,
  },
  desktopProfileTabs: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8,
  },
  desktopProfileTab: {
    minHeight: 38,
    paddingHorizontal: 12,
    borderRadius: 19,
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    backgroundColor: "#171512",
    borderWidth: 1,
    borderColor: "#403522",
  },
  desktopProfileTabActive: {
    backgroundColor: "#d7a955",
    borderColor: "#f0ca82",
  },
  desktopProfileTabText: { color: "#c7bda9", fontSize: 12, fontWeight: "800" },
  desktopProfileTabTextActive: { color: "#17120b" },
  desktopProfileTabCount: {
    minWidth: 19,
    height: 19,
    paddingHorizontal: 5,
    borderRadius: 10,
    textAlign: "center",
    color: "#ac9671",
    fontSize: 10,
    fontWeight: "900",
    lineHeight: 19,
    backgroundColor: "#2b251c",
  },
  desktopProfileTabCountActive: {
    color: "#f6dfb3",
    backgroundColor: "#5e421c",
  },
  desktopProfileVideoGrid: {
    paddingHorizontal: 0,
    paddingTop: 0,
    paddingBottom: 32,
  },
  desktopProfileEmpty: {
    width: "100%",
    minHeight: 260,
    padding: 28,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#111111",
    borderWidth: 1,
    borderColor: "#29241e",
  },
  desktopProfileEmptyTitle: {
    marginTop: 14,
    color: "#e6dfd5",
    fontSize: 18,
    fontWeight: "900",
  },
  desktopProfileEmptyText: {
    marginTop: 7,
    color: "#837b71",
    fontSize: 13,
    textAlign: "center",
  },
  desktopProfileEmptyButton: {
    height: 38,
    marginTop: 18,
    paddingHorizontal: 18,
    borderRadius: 19,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#d7a955",
  },
  desktopProfileEmptyButtonText: {
    color: "#17120b",
    fontSize: 13,
    fontWeight: "900",
  },
  desktopLibraryScroll: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    backgroundColor: "#090909",
  },
  desktopLibraryContent: {
    width: "100%",
    padding: 24,
    paddingBottom: 52,
    gap: 18,
  },
  desktopLibraryHero: {
    width: "100%",
    minHeight: 132,
    paddingHorizontal: 26,
    paddingVertical: 22,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: "#4d3b24",
    backgroundColor: "#15130f",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 22,
  },
  desktopLibraryHeroCopy: {
    minWidth: 240,
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 17,
  },
  desktopLibraryHeroIcon: {
    width: 58,
    height: 58,
    borderRadius: 18,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#d7a955",
  },
  desktopHistoryHeroIcon: { backgroundColor: "#66b5bd" },
  desktopLibraryHeroText: { minWidth: 0, flex: 1 },
  desktopLibraryTitle: { color: "#f7f0e5", fontSize: 27, fontWeight: "900" },
  desktopLibrarySubtitle: {
    marginTop: 7,
    color: "#9a9185",
    fontSize: 13,
    lineHeight: 20,
  },
  desktopLibraryHeroActions: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 10,
  },
  desktopLibrarySummaryBadge: {
    minWidth: 84,
    height: 45,
    paddingHorizontal: 13,
    borderRadius: 12,
    flexDirection: "row",
    alignItems: "baseline",
    justifyContent: "center",
    gap: 5,
    backgroundColor: "#211b13",
    borderWidth: 1,
    borderColor: "#5f492b",
  },
  desktopLibrarySummaryValue: {
    color: "#f0ca82",
    fontSize: 20,
    fontWeight: "900",
  },
  desktopLibrarySummaryLabel: {
    color: "#a99779",
    fontSize: 11,
    fontWeight: "700",
  },
  desktopLibraryRefreshButton: {
    height: 42,
    paddingHorizontal: 15,
    borderRadius: 21,
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    backgroundColor: "#1c1914",
    borderWidth: 1,
    borderColor: "#554226",
  },
  desktopLibraryRefreshText: {
    color: "#e6c88f",
    fontSize: 12,
    fontWeight: "800",
  },
  desktopLibraryError: {
    width: "100%",
    minHeight: 42,
    paddingHorizontal: 14,
    borderRadius: 10,
    flexDirection: "row",
    alignItems: "center",
    gap: 9,
    backgroundColor: "#30191a",
    borderWidth: 1,
    borderColor: "#6f3134",
  },
  desktopLibraryErrorText: { flex: 1, color: "#ffb6b6", fontSize: 12 },
  desktopLibrarySectionHeader: {
    width: "100%",
    paddingTop: 3,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: 12,
  },
  desktopLibrarySectionTitle: {
    color: "#f1ece4",
    fontSize: 20,
    fontWeight: "900",
  },
  desktopLibrarySectionSubtitle: {
    marginTop: 5,
    color: "#81786c",
    fontSize: 12,
  },
  desktopLibraryInlineEmpty: {
    width: "100%",
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderRadius: 11,
    color: "#8e8579",
    fontSize: 12,
    backgroundColor: "#11110f",
    borderWidth: 1,
    borderColor: "#29241d",
  },
  subscribedChannelList: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 9,
  },
  subscribedChannelChip: {
    maxWidth: 300,
    minHeight: 42,
    paddingLeft: 6,
    paddingRight: 8,
    borderRadius: 22,
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    backgroundColor: "#171512",
    borderWidth: 1,
    borderColor: "#514127",
  },
  subscribedChannelAvatar: {
    width: 31,
    height: 31,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#302515",
  },
  subscribedChannelAvatarText: {
    color: "#f0ca82",
    fontSize: 12,
    fontWeight: "900",
  },
  subscribedChannelName: {
    maxWidth: 180,
    color: "#ddd3c4",
    fontSize: 12,
    fontWeight: "800",
  },
  subscribedChannelRemove: {
    width: 27,
    height: 27,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#24211c",
  },
  desktopLibraryVideoGrid: {
    paddingHorizontal: 0,
    paddingTop: 0,
    paddingBottom: 12,
  },
  desktopLibraryPagination: {
    width: "100%",
    paddingBottom: 8,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
  },
  desktopLibraryPageSummary: {
    color: "#a99f92",
    fontSize: 12,
    fontWeight: "700",
  },
  desktopLibraryEmpty: {
    width: "100%",
    minHeight: 235,
    padding: 28,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#111111",
    borderWidth: 1,
    borderColor: "#29241e",
  },
  desktopLibraryEmptyTitle: {
    marginTop: 14,
    color: "#e6dfd5",
    fontSize: 18,
    fontWeight: "900",
  },
  desktopLibraryEmptyText: {
    marginTop: 7,
    color: "#837b71",
    fontSize: 13,
    textAlign: "center",
  },
  channelDiscoveryGrid: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
  },
  channelDiscoveryCard: {
    minWidth: 260,
    flexGrow: 1,
    flexBasis: 310,
    height: 78,
    padding: 10,
    borderRadius: 13,
    flexDirection: "row",
    alignItems: "center",
    gap: 11,
    backgroundColor: "#141414",
    borderWidth: 1,
    borderColor: "#302820",
  },
  channelDiscoveryImage: {
    width: 54,
    height: 54,
    borderRadius: 27,
    backgroundColor: "#222",
  },
  channelDiscoveryCopy: { minWidth: 0, flex: 1 },
  channelDiscoveryName: { color: "#eee7dc", fontSize: 13, fontWeight: "900" },
  channelDiscoveryMeta: { marginTop: 5, color: "#81796e", fontSize: 11 },
  channelDiscoverySubscribe: {
    height: 34,
    paddingHorizontal: 12,
    borderRadius: 17,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    backgroundColor: "#d7a955",
  },
  channelDiscoverySubscribeText: {
    color: "#17120b",
    fontSize: 12,
    fontWeight: "900",
  },
  header: {
    height: 72,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 24,
    gap: 10,
    backgroundColor: "rgba(2,9,8,.90)",
    borderBottomWidth: 1,
    borderBottomColor: "rgba(215,182,93,.16)",
    overflow: "visible",
    zIndex: 50,
  },
  searchArea: {
    height: 42,
    maxWidth: 700,
    flex: 1,
    position: "relative",
    zIndex: 60,
  },
  searchShell: {
    width: "100%",
    height: 42,
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "rgba(40,201,154,.35)",
    borderRadius: 22,
    overflow: "hidden",
    backgroundColor: "rgba(5,23,18,.74)",
  },
  searchInput: {
    flex: 1,
    height: "100%",
    paddingHorizontal: 18,
    fontFamily: MISANS,
    fontSize: 15,
    fontWeight: "400",
    color: "#f2f5f4",
    outlineStyle: "none",
  } as never,
  clearButton: {
    width: 40,
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  searchButton: {
    width: 78,
    height: "100%",
    flexDirection: "row",
    gap: 5,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(40,201,154,.10)",
    borderLeftWidth: 1,
    borderLeftColor: "rgba(40,201,154,.28)",
  },
  searchButtonText: {
    fontFamily: MISANS,
    color: "#28c99a",
    fontSize: 13,
    fontWeight: "600",
  },
  searchSuggestions: {
    position: "absolute",
    top: 48,
    left: 0,
    right: 0,
    borderRadius: 13,
    overflow: "hidden",
    backgroundColor: "#151515",
    borderWidth: 1,
    borderColor: "#554226",
    shadowColor: "#000",
    shadowOpacity: 0.58,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 10 },
    elevation: 20,
  },
  searchSuggestionHeader: {
    minHeight: 38,
    paddingHorizontal: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#2f281f",
    backgroundColor: "#191713",
  },
  searchSuggestionHeading: {
    color: "#e6c88f",
    fontSize: 12,
    fontWeight: "800",
  },
  searchSuggestionHint: { color: "#82796d", fontSize: 11 },
  searchSuggestionItem: {
    minHeight: 48,
    paddingHorizontal: 13,
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#24211d",
    backgroundColor: "#151515",
  },
  searchSuggestionItemPressed: { backgroundColor: "#292116" },
  searchSuggestionIcon: {
    width: 28,
    height: 28,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#241e16",
  },
  searchSuggestionCopy: { flex: 1, minWidth: 0 },
  searchSuggestionText: { color: "#f0ebe3", fontSize: 14, fontWeight: "700" },
  searchSuggestionSource: { color: "#8d8376", fontSize: 10, marginTop: 2 },
  roundButton: {
    width: 42,
    height: 42,
    borderRadius: 21,
    backgroundColor: "rgba(5,23,18,.72)",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.30)",
    alignItems: "center",
    justifyContent: "center",
  },
  headerSpacer: { width: 16 },
  createButton: {
    height: 40,
    paddingHorizontal: 16,
    borderRadius: 20,
    backgroundColor: "#28c99a",
    flexDirection: "row",
    gap: 7,
    alignItems: "center",
  },
  createText: {
    fontFamily: MISANS,
    fontSize: 15,
    fontWeight: "600",
    color: "#04110d",
  },
  androidDownloadButton: {
    height: 40,
    paddingHorizontal: 15,
    borderRadius: 20,
    backgroundColor: "rgba(5,18,15,.76)",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.62)",
    flexDirection: "row",
    gap: 7,
    alignItems: "center",
  },
  androidDownloadButtonText: {
    fontFamily: MISANS,
    fontSize: 15,
    fontWeight: "600",
    color: "#f2f5f4",
  },
  userAvatar: {
    width: 34,
    height: 34,
    borderRadius: 17,
    backgroundColor: "#061511",
    borderWidth: 1,
    borderColor: "#d7a955",
    alignItems: "center",
    justifyContent: "center",
  },
  userAvatarText: { color: "white", fontWeight: "800", fontSize: 15 },
  accountCard: {
    width: 360,
    maxWidth: "90vw" as never,
    borderRadius: 18,
    paddingHorizontal: 28,
    paddingVertical: 28,
    alignItems: "center",
    backgroundColor: "#151515",
    borderWidth: 1,
    borderColor: "#6d5634",
  },
  accountAvatar: {
    width: 68,
    height: 68,
    borderRadius: 34,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#2a2116",
    borderWidth: 1,
    borderColor: "#d7a955",
  },
  accountAvatarText: { color: "white", fontSize: 28, fontWeight: "800" },
  accountName: {
    marginTop: 16,
    color: "#f5efe5",
    fontSize: 20,
    fontWeight: "800",
  },
  accountEmail: { marginTop: 6, color: "#b8b1a7", fontSize: 14 },
  accountStatus: { marginTop: 12, color: "#d7a955", fontSize: 13 },
  accountNotice: {
    width: "100%",
    marginTop: 12,
    paddingHorizontal: 12,
    paddingVertical: 9,
    borderRadius: 9,
    color: "#bdeee0",
    fontSize: 12,
    lineHeight: 18,
    textAlign: "center",
    backgroundColor: "rgba(40,201,154,.10)",
    borderWidth: 1,
    borderColor: "rgba(40,201,154,.28)",
  },
  accountVipRefreshAction: {
    width: "100%",
    height: 40,
    marginTop: 18,
    borderRadius: 20,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 7,
    backgroundColor: "rgba(40,201,154,.12)",
    borderWidth: 1,
    borderColor: "rgba(40,201,154,.45)",
  },
  accountVipRefreshText: { color: "#bdeee0", fontSize: 13, fontWeight: "700" },
  accountModeTabs: {
    width: "100%",
    marginTop: 18,
    padding: 3,
    borderRadius: 12,
    flexDirection: "row",
    gap: 4,
    backgroundColor: "#0d0d0d",
    borderWidth: 1,
    borderColor: "#3d352b",
  },
  accountModeTab: {
    flex: 1,
    height: 34,
    borderRadius: 9,
    alignItems: "center",
    justifyContent: "center",
  },
  accountModeTabActive: { backgroundColor: "#28c99a" },
  accountModeTabText: { color: "#978f84", fontSize: 13, fontWeight: "700" },
  accountModeTabTextActive: { color: "#04110d" },
  accountInput: {
    width: "100%",
    height: 44,
    marginTop: 12,
    paddingHorizontal: 14,
    borderRadius: 10,
    color: "#f5efe5",
    backgroundColor: "#0d0d0d",
    borderWidth: 1,
    borderColor: "#4d4131",
  },
  accountError: {
    width: "100%",
    marginTop: 10,
    color: "#ff9c9c",
    fontSize: 12,
  },
  accountAction: {
    width: "100%",
    height: 42,
    marginTop: 22,
    borderRadius: 21,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#d7a955",
  },
  accountActionDisabled: { opacity: 0.55 },
  accountActionText: { color: "#17120b", fontSize: 15, fontWeight: "800" },
  accountAdminAction: {
    width: "100%",
    height: 42,
    marginTop: 10,
    borderRadius: 21,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 7,
    backgroundColor: "#201a13",
    borderWidth: 1,
    borderColor: "#80643b",
  },
  accountAdminActionText: { color: "#e6c88f", fontSize: 14, fontWeight: "800" },
  accountAdminHint: { marginTop: 8, color: "#81786d", fontSize: 11 },
  accountLogoutAction: {
    marginTop: 8,
    paddingHorizontal: 14,
    paddingVertical: 8,
  },
  accountLogoutText: { color: "#a79f95", fontSize: 12, fontWeight: "600" },
  accountClose: { marginTop: 14, padding: 8 },
  accountCloseText: { color: "#aaa49b", fontSize: 14 },
  androidDownloadCard: {
    width: 390,
    maxWidth: "92vw" as never,
    borderRadius: 20,
    paddingHorizontal: 30,
    paddingVertical: 28,
    alignItems: "center",
    backgroundColor: "#151515",
    borderWidth: 1,
    borderColor: "#80643b",
  },
  androidDownloadIcon: {
    width: 54,
    height: 54,
    borderRadius: 27,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#d7a955",
  },
  androidDownloadTitle: {
    marginTop: 16,
    color: "#f5efe5",
    fontSize: 20,
    fontWeight: "800",
  },
  androidDownloadSubtitle: { marginTop: 7, color: "#aaa49b", fontSize: 14 },
  androidDownloadQr: {
    width: 220,
    height: 220,
    marginTop: 20,
    marginBottom: 14,
    borderRadius: 14,
    backgroundColor: "white",
  },
  androidDownloadVersion: {
    marginBottom: 18,
    color: "#b89a6a",
    fontSize: 12,
  },
  androidDownloadClose: { marginTop: 12, padding: 8 },
  androidDownloadCloseText: { color: "#aaa49b", fontSize: 14 },
  content: {
    flex: 1,
    height: 0,
    minHeight: 0,
    overflowY: "auto",
    backgroundColor: "transparent",
  } as never,
  sortChipActive: { backgroundColor: "#138563", borderColor: "#28c99a" },
  sortLabelActive: { color: "#ffffff" },
  grid: {
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
    paddingHorizontal: 24,
    paddingTop: 10,
    paddingBottom: 36,
  },
  pagination: {
    paddingHorizontal: 24,
    paddingBottom: 36,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 8,
  },
  paginationTop: {
    paddingHorizontal: 24,
    paddingTop: 16,
    paddingBottom: 8,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: 8,
  },
  paginationSummary: {
    fontFamily: INTER,
    color: "#8b9692",
    fontSize: 13,
    fontWeight: "500",
    marginRight: 8,
  },
  pageButton: {
    height: 36,
    paddingHorizontal: 15,
    borderRadius: 18,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(7,21,17,.78)",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.38)",
  },
  pageButtonDisabled: { opacity: 0.35 },
  pageButtonText: {
    fontFamily: INTER,
    color: "#d7b65d",
    fontSize: 13,
    fontWeight: "500",
  },
  pageNumber: {
    width: 36,
    height: 36,
    borderRadius: 18,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(7,21,17,.78)",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.25)",
  },
  pageNumberActive: { backgroundColor: "#28c99a", borderColor: "#52e2b6" },
  pageNumberText: {
    fontFamily: INTER,
    color: "#b9c2bf",
    fontSize: 13,
    fontWeight: "500",
  },
  pageNumberTextActive: { color: "#04110d", fontWeight: "700" },
  card: {
    marginBottom: 4,
    paddingBottom: 13,
    borderRadius: 15,
    overflow: "hidden",
    backgroundColor: "rgba(4,20,16,.86)",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.22)",
    shadowColor: "#000",
    shadowOpacity: 0.2,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 6 },
  },
  thumbnailWrap: {
    width: "100%",
    aspectRatio: 16 / 9,
    borderRadius: 14,
    overflow: "hidden",
    backgroundColor: "#06110e",
    position: "relative",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.24)",
  },
  thumbnail: { width: "100%", height: "100%" },
  vipLockedPlaceholder: {
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 22,
    backgroundColor: "#000",
  },
  vipLockedIcon: {
    width: 52,
    height: 52,
    borderRadius: 26,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#28c99a",
    borderWidth: 1,
    borderColor: "#81e6c8",
  },
  vipLockedTitle: {
    fontFamily: MISANS,
    marginTop: 12,
    color: "#f2f5f4",
    fontSize: 16,
    fontWeight: "700",
  },
  vipLockedHint: {
    fontFamily: MISANS,
    marginTop: 5,
    color: "#78827f",
    fontSize: 12,
  },
  hoverPreviewLayer: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 1,
    pointerEvents: "none",
    backgroundColor: "transparent",
  },
  hoverPreviewMessage: {
    ...StyleSheet.absoluteFillObject,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    backgroundColor: "rgba(0,0,0,.38)",
  },
  hoverPreviewMessageText: {
    maxWidth: 300,
    color: "white",
    fontSize: 12,
    lineHeight: 18,
    fontWeight: "700",
    textAlign: "center",
  },
  hoverPreviewBadge: {
    position: "absolute",
    left: 7,
    top: 7,
    zIndex: 2,
    height: 25,
    paddingHorizontal: 8,
    borderRadius: 13,
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    backgroundColor: "rgba(215,169,85,.94)",
  },
  hoverPreviewBadgeText: { color: "#17120b", fontSize: 11, fontWeight: "800" },
  cardPaidBadge: {
    position: "absolute",
    right: 7,
    top: 7,
    zIndex: 4,
    height: 27,
    maxWidth: "62%",
    paddingHorizontal: 9,
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    backgroundColor: "rgba(215,182,93,.96)",
    borderWidth: 1,
    borderColor: "rgba(255,229,155,.72)",
  },
  cardPaidBadgeText: {
    fontFamily: MISANS,
    color: "#17120b",
    fontSize: 11,
    fontWeight: "800",
  },
  cardPaidBadgeWithAd: { top: 40 },
  cardAdBadge: {
    position: "absolute",
    right: 7,
    top: 7,
    zIndex: 5,
    height: 27,
    paddingHorizontal: 9,
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    backgroundColor: "rgba(174,73,47,.96)",
    borderWidth: 1,
    borderColor: "rgba(255,188,147,.82)",
  },
  cardAdBadgeText: {
    fontFamily: MISANS,
    color: "#fff4dd",
    fontSize: 11,
    fontWeight: "900",
  },
  cardVipBadge: {
    position: "absolute",
    left: 7,
    top: 7,
    zIndex: 4,
    height: 27,
    paddingHorizontal: 9,
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    backgroundColor: "rgba(40,201,154,.96)",
    borderWidth: 1,
    borderColor: "rgba(129,230,200,.75)",
  },
  cardVipBadgeText: {
    fontFamily: MISANS,
    color: "#04110d",
    fontSize: 11,
    fontWeight: "800",
  },
  cardContextBadge: {
    position: "absolute",
    left: 7,
    bottom: 7,
    zIndex: 3,
    maxWidth: "75%",
    minHeight: 25,
    paddingHorizontal: 8,
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(12,12,12,.84)",
    borderWidth: 1,
    borderColor: "rgba(215,169,85,.52)",
  },
  cardContextText: { color: "#f0d8aa", fontSize: 10, fontWeight: "800" },
  durationBadge: {
    position: "absolute",
    right: 6,
    bottom: 6,
    zIndex: 3,
    backgroundColor: "rgba(0,0,0,.78)",
    borderRadius: 5,
    paddingHorizontal: 5,
    paddingVertical: 3,
  },
  durationText: {
    fontFamily: INTER,
    color: "white",
    fontSize: 12,
    fontWeight: "600",
  },
  cardInfo: {
    flexDirection: "row",
    gap: 8,
    paddingTop: 8,
    paddingHorizontal: 12,
    alignItems: "flex-start",
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: "rgba(40,201,154,.10)",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.55)",
    alignItems: "center",
    justifyContent: "center",
  },
  avatarText: {
    fontFamily: INTER,
    color: "#d7b65d",
    fontSize: 13,
    fontWeight: "600",
  },
  cardCopy: { flex: 1, minWidth: 0 },
  cardTitle: {
    fontFamily: MISANS,
    fontSize: 14,
    lineHeight: 18,
    color: "#f2f5f4",
    fontWeight: "400",
    marginBottom: 4,
  },
  channel: {
    fontFamily: MISANS,
    fontSize: 12,
    lineHeight: 16,
    fontWeight: "400",
    color: "#8b9692",
    marginBottom: 2,
  },
  meta: {
    fontFamily: INTER,
    fontSize: 11,
    lineHeight: 15,
    fontWeight: "400",
    color: "#65706c",
  },
  adDeliveryHint: {
    fontFamily: INTER,
    fontSize: 11,
    lineHeight: 15,
    fontWeight: "400",
    color: "#ffad80",
    marginTop: 3,
  },
  rankingHint: {
    fontFamily: INTER,
    fontSize: 11,
    lineHeight: 15,
    fontWeight: "400",
    color: "#d7b65d",
    marginTop: 3,
  },
  emptyState: { alignItems: "center", paddingVertical: 100 },
  emptyTitle: {
    fontSize: 20,
    color: "#f2eee7",
    fontWeight: "700",
    marginTop: 18,
  },
  emptyText: { fontSize: 14, color: "#777", marginTop: 8 },
  loadingText: { textAlign: "center", color: "#777", paddingVertical: 50 },
  modalBackdrop: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,.76)",
    alignItems: "center",
    justifyContent: "center",
    padding: 40,
  },
  modalCloseArea: { ...StyleSheet.absoluteFillObject },
  floatingPlayerLayer: {
    position: "fixed" as never,
    inset: 0,
    zIndex: 1000,
    pointerEvents: "box-none",
  } as never,
  floatingPlayerLayerMaximized: {
    overflowX: "hidden",
    overflowY: "auto",
  } as never,
  playerCard: {
    position: "absolute",
    backgroundColor: "#06110e",
    borderRadius: 14,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#285848",
    shadowColor: "#000",
    shadowOpacity: 0.58,
    shadowRadius: 34,
    shadowOffset: { width: 0, height: 12 },
  },
  playerHeader: {
    height: 42,
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 20,
    paddingRight: 10,
    backgroundColor: "#07130f",
    borderBottomWidth: 1,
    borderBottomColor: "#1b4035",
    cursor: "move",
    userSelect: "none",
  } as never,
  playerHeaderHoverZone: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 50,
    zIndex: 8,
    overflow: "hidden",
  } as never,
  playerHeaderHoverZoneHidden: {
    display: "none",
  } as never,
  playerHeaderVisible: {
    opacity: 1,
    transform: [{ translateY: 0 }],
    transitionProperty: "opacity, transform",
    transitionDuration: "160ms",
  } as never,
  playerHeaderHidden: {
    opacity: 0,
    pointerEvents: "none",
    transform: [{ translateY: -8 }],
    transitionProperty: "opacity, transform",
    transitionDuration: "220ms",
  } as never,
  playerHeaderCopy: {
    flex: 1,
    minWidth: 0,
    cursor: "move",
    userSelect: "none",
    touchAction: "none",
  } as never,
  playerGlobalControlsHost: {
    minWidth: 0,
    minHeight: 48,
    marginLeft: 4,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    cursor: "default",
  } as never,
  playerHeaderMediaControls: {
    minWidth: 0,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 8,
  },
  playerGlobalIconButton: {
    width: 48,
    height: 48,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 24,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#8a6b2a",
    backgroundColor: "#071510",
    cursor: "pointer",
  } as never,
  playerMediaCompactButton: {
    height: 34,
    minWidth: 108,
    maxWidth: 174,
    paddingLeft: 10,
    paddingRight: 9,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 7,
    overflow: "hidden",
    borderRadius: 7,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#2f765f",
    backgroundColor: "#071510",
    color: "#edf7f3",
    fontFamily: MISANS,
    fontSize: 12,
    fontWeight: "600",
    whiteSpace: "nowrap",
    cursor: "pointer",
  } as never,
  playerMediaFullSelect: {
    width: "100%",
    height: 42,
    marginTop: 15,
    paddingHorizontal: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#34745f",
    backgroundColor: "#04100c",
    color: "#edf7f3",
    fontFamily: MISANS,
    fontSize: 13,
    cursor: "pointer",
  } as never,
  playerMediaRecommendation: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 9,
    padding: 11,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "rgba(40,201,154,.35)",
    backgroundColor: "rgba(40,201,154,.08)",
  },
  playerMediaRecommendationText: {
    flex: 1,
    fontFamily: MISANS,
    color: "#bdeee0",
    fontSize: 12,
    lineHeight: 18,
  },
  playerOpenModeFieldset: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    margin: 0,
    marginTop: 8,
    padding: 12,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#284f43",
    borderRadius: 8,
    color: "#d9eee8",
  } as never,
  playerOpenModeOption: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontFamily: MISANS,
    fontSize: 13,
    cursor: "pointer",
  } as never,
  playerOpenModeInline: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    padding: 3,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#285848",
    backgroundColor: "#06110e",
  },
  playerOpenModeInlineButton: {
    height: 32,
    paddingHorizontal: 10,
    borderRadius: 7,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    backgroundColor: "transparent",
    cursor: "pointer",
  } as never,
  playerOpenModeInlineButtonActive: {
    backgroundColor: "#126b51",
  },
  playerOpenModeInlineText: {
    fontFamily: MISANS,
    color: "#bff7e6",
    fontSize: 12,
    fontWeight: "700",
  },
  playerTitleLine: {
    flexDirection: "row",
    alignItems: "center",
    gap: 9,
    minWidth: 0,
  },
  playerTitle: {
    fontFamily: MISANS,
    color: "#f2f5f4",
    fontSize: 18,
    lineHeight: 24,
    fontWeight: "600",
    flex: 1,
    minWidth: 0,
  },
  playerPaidBadge: {
    height: 25,
    maxWidth: 150,
    paddingHorizontal: 8,
    borderRadius: 13,
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
    backgroundColor: "#d7b65d",
  },
  playerPaidBadgeText: {
    fontFamily: MISANS,
    color: "#17120b",
    fontSize: 11,
    fontWeight: "800",
  },
  playerAdBadge: {
    height: 25,
    paddingHorizontal: 8,
    borderRadius: 13,
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
    backgroundColor: "#ae492f",
    borderWidth: 1,
    borderColor: "#e89a73",
  },
  playerAdBadgeText: {
    fontFamily: MISANS,
    color: "#fff4dd",
    fontSize: 11,
    fontWeight: "900",
  },
  playerVipBadge: {
    height: 25,
    paddingHorizontal: 8,
    borderRadius: 13,
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    flexShrink: 0,
    backgroundColor: "#28c99a",
  },
  playerVipBadgeText: {
    fontFamily: MISANS,
    color: "#04110d",
    fontSize: 11,
    fontWeight: "800",
  },
  playerChannel: {
    fontFamily: MISANS,
    color: "#8b9692",
    fontSize: 13,
    fontWeight: "400",
    marginTop: 3,
  },
  playerWindowActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    marginLeft: 12,
  },
  playerWindowButton: {
    width: 34,
    height: 34,
    borderRadius: 17,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#0d211b",
    borderWidth: 1,
    borderColor: "#285848",
    cursor: "pointer",
  } as never,
  playerTrackButton: {
    backgroundColor: "rgba(40,201,154,.12)",
    borderColor: "#34745f",
  },
  playerWindowButtonDisabled: {
    opacity: 0.35,
    cursor: "default",
  } as never,
  playerClose: {
    width: 38,
    height: 38,
    borderRadius: 19,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  } as never,
  floatingPlayerBody: { flex: 1, minHeight: 0, backgroundColor: "#06110e" },
  floatingPlayerBodyMaximized: {
    flex: "none",
    minHeight: "auto",
    overflow: "visible",
  } as never,
  floatingPlayerBodyContent: {
    alignItems: "stretch",
    minWidth: "100%",
    paddingBottom: 18,
    width: "100%",
  },
  floatingPlayerResizeHandle: {
    position: "absolute",
    right: 0,
    bottom: 0,
    width: 32,
    height: 32,
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: 12,
    backgroundColor: "rgba(7,28,23,.96)",
    borderLeftWidth: 1,
    borderTopWidth: 1,
    borderColor: "#34745f",
    cursor: "nwse-resize",
    touchAction: "none",
    userSelect: "none",
    zIndex: 4,
  } as never,
  playerVariantBarScroll: {
    height: 56,
    maxHeight: 56,
    flexGrow: 0,
    backgroundColor: "#0b1b16",
  },
  playerVariantBarScrollEmpty: {
    height: 1,
    minHeight: 1,
    maxHeight: 1,
    overflow: "hidden",
    backgroundColor: "transparent",
  },
  playerStage: {
    alignSelf: "stretch",
    minWidth: "100%",
    position: "relative",
    width: "100%",
  },
  playerMediaFrame: {
    alignSelf: "stretch",
    width: "100%",
    aspectRatio: 16 / 9,
    minHeight: 220,
    position: "relative",
    overflow: "hidden",
    backgroundColor: "#030705",
  } as never,
  playerMediaFrameViewport: {
    aspectRatio: undefined,
    height: "calc(100dvh - 2px)",
    minHeight: 0,
  } as never,
  // Explicitly reset the viewport sizing after the floating player is restored.
  // React Native Web otherwise can retain the previous calculated height.
  playerMediaFrameRegular: {
    aspectRatio: 16 / 9,
    height: "auto",
    minHeight: 220,
    flex: "none",
    flexShrink: 0,
  } as never,
  playerStageMaximized: {
    flexShrink: 0,
    minHeight: 0,
  },
  playerVariantBar: {
    minHeight: 56,
    minWidth: "100%",
    paddingHorizontal: 14,
    paddingVertical: 9,
    backgroundColor: "#0b1b16",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flexWrap: "nowrap",
  } as never,
  playerVariantBarEmpty: {
    minHeight: 1,
    paddingHorizontal: 0,
    paddingVertical: 0,
    backgroundColor: "transparent",
  },
  playerVariantLabel: {
    fontFamily: MISANS,
    color: "#28c99a",
    fontSize: 13,
    fontWeight: "600",
    flexShrink: 0,
  },
  playerSelect: {
    height: 34,
    width: 160,
    minWidth: 132,
    maxWidth: 200,
    flexShrink: 1,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#2a594b",
    backgroundColor: "#06110e",
    color: "#f2f5f4",
    fontFamily: MISANS,
    fontSize: 13,
    paddingHorizontal: 8,
  },
  playerLoopModeButton: {
    height: 34,
    paddingHorizontal: 10,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#2f765f",
    backgroundColor: "#0a211a",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    flexShrink: 0,
    cursor: "pointer",
  } as never,
  playerLoopModeText: {
    fontFamily: MISANS,
    color: "#bdeee0",
    fontSize: 12,
    fontWeight: "600",
  },
  playerCommerceEditorButton: {
    height: 34,
    paddingHorizontal: 11,
    borderRadius: 7,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    flexShrink: 0,
    backgroundColor: "#d7b65d",
    borderWidth: 1,
    borderColor: "#f0cf88",
    cursor: "pointer",
  } as never,
  playerCommerceEditorText: {
    fontFamily: MISANS,
    color: "#17120b",
    fontSize: 12,
    fontWeight: "900",
  },
  playerSourceHint: {
    fontFamily: MISANS,
    color: "#65706c",
    fontSize: 12,
    minWidth: 82,
    maxWidth: 138,
    flexShrink: 1,
  },
  playerEdgeButton: {
    height: 34,
    minWidth: 112,
    maxWidth: 170,
    paddingHorizontal: 9,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#284f43",
    backgroundColor: "#071510",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    flexShrink: 1,
    cursor: "pointer",
  } as never,
  playerQualityQuickSelect: {
    height: 34,
    minWidth: 154,
    maxWidth: 230,
    paddingLeft: 9,
    paddingRight: 28,
    borderRadius: 7,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#284f43",
    backgroundColor: "#071510",
    color: "#8fc7b6",
    fontFamily: MISANS,
    fontSize: 12,
    cursor: "pointer",
  } as never,
  playerDowngradeHint: {
    flexShrink: 1,
    minWidth: 0,
    maxWidth: 220,
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontFamily: MISANS,
    fontSize: 12,
    color: "#28c99a",
    whiteSpace: "nowrap",
  } as never,
  playerDowngradeInlineControl: {
    height: 34,
    width: 132,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 7,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#284f43",
    backgroundColor: "#071510",
  } as never,
  playerDowngradeInlineRange: {
    width: "100%",
    height: 16,
    margin: 0,
    accentColor: "#28c99a",
    cursor: "pointer",
  } as never,
  playerPolicyInlineControl: {
    height: 42,
    width: 212,
    flexShrink: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    paddingLeft: 9,
    paddingRight: 9,
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#284f43",
    backgroundColor: "#071510",
  } as never,
  playerPolicyInlineLabel: {
    minWidth: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    color: "#bdeee0",
    fontFamily: MISANS,
    fontSize: 12,
    fontWeight: "700",
    whiteSpace: "nowrap",
  } as never,
  playerPolicyInlineRange: {
    width: 68,
    minWidth: 68,
    height: 16,
    margin: 0,
    accentColor: "#28c99a",
    cursor: "pointer",
  } as never,
  playerEdgeButtonText: {
    minWidth: 0,
    flexShrink: 1,
    fontFamily: MISANS,
    color: "#8fc7b6",
    fontSize: 12,
  },
  playerEdgeStatusDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    flexShrink: 0,
  },
  playerEdgeStatusHealthy: {
    backgroundColor: "#27d49b",
  },
  playerEdgeStatusChecking: {
    backgroundColor: "#d7b65d",
  },
  playerEdgeModalBackdrop: {
    flex: 1,
    padding: 20,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.66)",
  },
  playerEdgeModalCard: {
    width: 390,
    maxWidth: "94%",
    padding: 18,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#2f765f",
    backgroundColor: "#071510",
    shadowColor: "#000",
    shadowOpacity: 0.35,
    shadowRadius: 18,
    shadowOffset: { width: 0, height: 8 },
  },
  playerEdgeModalHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 14,
  },
  playerEdgeModalTitleRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  playerEdgeModalTitle: {
    fontFamily: MISANS,
    color: "#f2f5f4",
    fontSize: 17,
    fontWeight: "700",
  },
  playerEdgeModeRow: {
    flexDirection: "row",
    gap: 8,
    marginBottom: 4,
  },
  playerEdgeModeButton: {
    flex: 1,
    minHeight: 34,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#284f43",
    backgroundColor: "#0a1d17",
    cursor: "pointer",
  } as never,
  playerEdgeModeButtonActive: {
    borderColor: "#39c89c",
    backgroundColor: "#12362b",
  },
  playerEdgeModeButtonText: {
    fontFamily: MISANS,
    color: "#d9eee8",
    fontSize: 12,
    fontWeight: "700",
  },
  playerEdgeOptionList: {
    paddingTop: 6,
    gap: 6,
  },
  playerEdgeOptionScroller: {
    maxHeight: 220,
  },
  playerEdgeOptionRow: {
    minHeight: 46,
    paddingHorizontal: 10,
    paddingVertical: 6,
    flexDirection: "row",
    alignItems: "center",
    gap: 9,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#1f4439",
    backgroundColor: "#091a15",
    cursor: "pointer",
  } as never,
  playerEdgeOptionRowActive: {
    borderColor: "#39c89c",
    backgroundColor: "#103126",
  },
  playerEdgeOptionOrder: {
    width: 22,
    textAlign: "center",
    fontFamily: INTER,
    color: "#d7b65d",
    fontSize: 13,
    fontWeight: "800",
  },
  playerEdgeOptionCopy: {
    flex: 1,
    minWidth: 0,
  },
  playerEdgeOptionName: {
    fontFamily: MISANS,
    color: "#d9eee8",
    fontSize: 13,
    fontWeight: "700",
  },
  playerEdgeOptionHost: {
    marginTop: 2,
    fontFamily: INTER,
    color: "#6d9d8f",
    fontSize: 10,
  },
  playerEdgeOrderButtons: {
    flexDirection: "row",
    gap: 4,
  },
  playerEdgeOrderButton: {
    width: 30,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#284f43",
    backgroundColor: "#071510",
    cursor: "pointer",
  } as never,
  playerEdgeDetailLabel: {
    marginTop: 9,
    fontFamily: MISANS,
    color: "#6d9d8f",
    fontSize: 11,
  },
  playerEdgeDetailValue: {
    marginTop: 3,
    fontFamily: MISANS,
    color: "#d9eee8",
    fontSize: 13,
    lineHeight: 19,
  },
  playerSourceError: {
    fontFamily: MISANS,
    color: "#ffb4b4",
    fontSize: 12,
    minWidth: 82,
    maxWidth: 138,
    flexShrink: 1,
  },
  playerFaultToleranceStatus: {
    minWidth: 0,
    maxWidth: 640,
    flexBasis: "100%",
    flexGrow: 1,
    lineHeight: 18,
    textAlign: "right",
  },
  playerVolumeControl: {
    minHeight: 34,
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    paddingHorizontal: 9,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#315b4d",
    backgroundColor: "#071510",
    flexShrink: 0,
  },
  playerVolumeValue: {
    minWidth: 34,
    fontFamily: INTER,
    color: "#f2f5f4",
    fontSize: 12,
    fontWeight: "700",
    textAlign: "right",
  },
  resumePromptBanner: {
    minHeight: 66,
    width: "100%",
    paddingHorizontal: 14,
    paddingVertical: 10,
    backgroundColor: "#0d241c",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(40,201,154,.38)",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 10,
  } as never,
  resumePromptBannerBelowDrag: {
    position: "absolute",
    top: 50,
    left: 0,
    right: 0,
    width: "auto",
    zIndex: 7,
  } as never,
  resumePromptCopy: {
    minWidth: 250,
    flexGrow: 0,
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  } as never,
  resumePromptIcon: {
    width: 36,
    height: 36,
    borderRadius: 18,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#28c99a",
  },
  resumePromptTextBlock: {
    minWidth: 0,
    flex: 1,
  },
  resumePromptTitle: {
    fontFamily: MISANS,
    color: "#f2f5f4",
    fontSize: 14,
    fontWeight: "800",
  },
  resumePromptDescription: {
    marginTop: 3,
    fontFamily: MISANS,
    color: "#91aea5",
    fontSize: 11,
  },
  resumePromptActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flexShrink: 0,
  } as never,
  resumePromptSecondaryButton: {
    height: 36,
    paddingHorizontal: 12,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#071510",
    borderWidth: 1,
    borderColor: "#315b4d",
    cursor: "pointer",
  } as never,
  resumePromptSecondaryText: {
    fontFamily: MISANS,
    color: "#c8ddd6",
    fontSize: 12,
    fontWeight: "700",
  },
  resumePromptPrimaryButton: {
    height: 36,
    paddingHorizontal: 13,
    borderRadius: 8,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    backgroundColor: "#28c99a",
    cursor: "pointer",
  } as never,
  resumePromptPrimaryText: {
    fontFamily: MISANS,
    color: "#04110d",
    fontSize: 12,
    fontWeight: "800",
  },
  player: { width: "100%", aspectRatio: 16 / 9, backgroundColor: "black" },
  nativePlayerControlBar: {
    minHeight: 48,
    paddingHorizontal: 13,
    paddingVertical: 7,
    backgroundColor: "#071510",
    borderTopWidth: 1,
    borderColor: "#214d40",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  } as never,
  nativePlayerControlButton: {
    height: 34,
    paddingHorizontal: 11,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#315b4d",
    backgroundColor: "#0a211a",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    cursor: "pointer",
  } as never,
  nativePlayerControlText: {
    fontFamily: MISANS,
    color: "#d9f7ee",
    fontSize: 12,
    fontWeight: "600",
  },
  nativePlayerPrimaryButton: {
    height: 34,
    paddingHorizontal: 14,
    borderRadius: 8,
    backgroundColor: "#28c99a",
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    cursor: "pointer",
  } as never,
  nativePlayerPrimaryText: {
    fontFamily: MISANS,
    color: "#04110d",
    fontSize: 12,
    fontWeight: "800",
  },
  nativePlayerEngineBadge: {
    marginLeft: "auto",
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    paddingHorizontal: 10,
  } as never,
  nativePlayerEngineText: {
    fontFamily: MISANS,
    color: "#87a49b",
    fontSize: 11,
    fontWeight: "600",
  },
  paidGateOverlay: {
    position: "absolute",
    top: 56,
    left: 0,
    right: 0,
    zIndex: 20,
    aspectRatio: 16 / 9,
    alignItems: "center",
    justifyContent: "center",
    padding: 18,
    backgroundColor: "rgba(2,10,8,.88)",
  },
  paidGateCard: {
    width: "88%",
    maxWidth: 470,
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 21,
    borderRadius: 16,
    backgroundColor: "rgba(7,25,19,.98)",
    borderWidth: 1,
    borderColor: "rgba(215,182,93,.66)",
    shadowColor: "#000",
    shadowOpacity: 0.5,
    shadowRadius: 24,
    shadowOffset: { width: 0, height: 10 },
  },
  paidGateIcon: {
    width: 46,
    height: 46,
    borderRadius: 23,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 12,
    backgroundColor: "#d7b65d",
  },
  paidGateTitle: {
    fontFamily: MISANS,
    color: "#f2f5f4",
    fontSize: 20,
    lineHeight: 27,
    fontWeight: "700",
    textAlign: "center",
  },
  paidGateDescription: {
    fontFamily: MISANS,
    maxWidth: 400,
    marginTop: 8,
    color: "#9eaaa6",
    fontSize: 13,
    lineHeight: 19,
    textAlign: "center",
  },
  paidGateAccount: {
    width: "100%",
    marginTop: 14,
    paddingHorizontal: 13,
    paddingVertical: 10,
    borderRadius: 9,
    backgroundColor: "rgba(40,201,154,.08)",
    borderWidth: 1,
    borderColor: "rgba(40,201,154,.22)",
  },
  paidGateAccountName: {
    fontFamily: MISANS,
    color: "#e9f3ef",
    fontSize: 14,
    fontWeight: "600",
  },
  paidGateBalance: {
    fontFamily: INTER,
    marginTop: 4,
    color: "#d7b65d",
    fontSize: 12,
    fontWeight: "600",
  },
  paidGateMessage: {
    minHeight: 18,
    marginTop: 10,
    color: "#c2cbc8",
    fontSize: 12,
    textAlign: "center",
  },
  paidGateActions: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 9,
    marginTop: 11,
  },
  paidGatePrimaryAction: {
    minHeight: 40,
    minWidth: 154,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 16,
    borderRadius: 9,
    backgroundColor: "#d7b65d",
    cursor: "pointer",
  } as never,
  paidGatePrimaryText: {
    fontFamily: MISANS,
    color: "#17120b",
    fontSize: 14,
    fontWeight: "800",
  },
  paidGateSecondaryAction: {
    minHeight: 40,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 14,
    borderRadius: 9,
    backgroundColor: "#0b241c",
    borderWidth: 1,
    borderColor: "#2f765f",
    cursor: "pointer",
  } as never,
  paidGateSecondaryText: {
    fontFamily: MISANS,
    color: "#bdeee0",
    fontSize: 13,
    fontWeight: "700",
  },
  paidGateActionDisabled: { opacity: 0.55 },
  interactionPanel: {
    paddingHorizontal: 18,
    paddingVertical: 14,
    backgroundColor: "#07130f",
    borderTopWidth: 1,
    borderTopColor: "#1b4035",
  },
  interactionVideoTitleRow: {
    minHeight: 36,
    marginBottom: 12,
    flexDirection: "row",
    alignItems: "center",
    gap: 9,
    minWidth: 0,
  },
  interactionVideoTitleCopy: {
    flex: 1,
    minWidth: 0,
    flexDirection: "row",
    alignItems: "center",
    gap: 7,
    overflow: "hidden",
  },
  interactionWindowActionsHost: {
    marginLeft: "auto",
    flexShrink: 0,
    minHeight: 38,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  } as never,
  interactionTrackControlsHost: {
    flexShrink: 0,
    minHeight: 38,
    display: "flex",
    alignItems: "center",
  } as never,
  interactionTrackControls: {
    marginLeft: 4,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  interactionVideoTitle: {
    flexShrink: 1,
    minWidth: 0,
    fontFamily: MISANS,
    color: "#f2f5f4",
    fontSize: 18,
    lineHeight: 24,
    fontWeight: "600",
  },
  interactionVideoCategory: {
    flexShrink: 0,
    maxWidth: 190,
    fontFamily: MISANS,
    color: "#8fc7b6",
    fontSize: 13,
    lineHeight: 20,
    fontWeight: "500",
  },
  interactionHeader: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
  },
  interactionMetadata: {
    minWidth: 260,
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    overflow: "hidden",
  },
  interactionPlayerControlsHost: {
    maxWidth: "100%",
    marginLeft: "auto",
    flexShrink: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  } as never,
  interactionMediaControlsHost: {
    minHeight: 48,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
  } as never,
  interactionPlayerControls: {
    maxWidth: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: 8,
  },
  interactionCacheDiagnosticsHost: {
    width: "100%",
    marginTop: 12,
  } as never,
  playbackCacheDiagnostics: {
    width: "100%",
    overflow: "hidden",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#285848",
    borderRadius: 9,
    backgroundColor: "#050d0a",
    color: "#cce9df",
    fontFamily: MISANS,
  } as never,
  playbackCacheDiagnosticsSummary: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "9px 12px",
    cursor: "pointer",
    color: "#bff7e6",
    fontSize: 12,
    fontWeight: "800",
    userSelect: "none",
  } as never,
  playbackCacheDiagnosticsTotals: {
    color: "#6fae9b",
    fontSize: 11,
    fontWeight: "600",
  } as never,
  playbackIntelligenceOverview: {
    display: "grid",
    gridTemplateColumns: "minmax(260px, .9fr) minmax(320px, 1.1fr)",
    gap: 8,
    padding: "0 10px 10px",
  } as never,
  playbackDiagnosisCard: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    padding: "9px 10px",
    border: "1px solid",
    borderRadius: 7,
    color: "#b7d3ca",
    fontSize: 11,
    backgroundColor: "#07140f",
  } as never,
  playbackDiagnosisTitle: {
    color: "#d9fff2",
    fontSize: 12,
  } as never,
  playbackDiagnosisAction: {
    color: "#78ad9c",
  } as never,
  playbackDiagnosisMetrics: {
    marginTop: 2,
    color: "#e0bd72",
    fontFamily: "monospace",
  } as never,
  intelligentCachePlan: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
    padding: "9px 10px",
    border: "1px solid #244c40",
    borderRadius: 7,
    backgroundColor: "#07140f",
    fontSize: 11,
  } as never,
  intelligentCachePlanList: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    margin: 0,
    paddingLeft: 20,
    color: "#c6e0d7",
  } as never,
  intelligentCachePlanItem: {
    paddingLeft: 2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  } as never,
  playbackCacheDiagnosticsScroll: {
    maxHeight: 260,
    overflow: "auto",
    borderTop: "1px solid #183b30",
  } as never,
  playbackCacheDiagnosticsTable: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    fontSize: 11,
  } as never,
  playbackCacheDiagnosticsHead: {
    padding: "7px 9px",
    position: "sticky",
    top: 0,
    zIndex: 1,
    textAlign: "left",
    color: "#6fae9b",
    backgroundColor: "#081611",
    borderBottom: "1px solid #183b30",
  } as never,
  playbackCacheDiagnosticsCell: {
    padding: "7px 9px",
    color: "#a8c7bd",
    borderBottom: "1px solid rgba(40,88,72,.42)",
    whiteSpace: "nowrap",
  } as never,
  playbackCacheDiagnosticsResource: {
    width: "48%",
    padding: "7px 9px",
    borderBottom: "1px solid rgba(40,88,72,.42)",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  } as never,
  playbackCacheDiagnosticsType: {
    display: "inline-block",
    marginRight: 7,
    padding: "2px 5px",
    borderRadius: 4,
    color: "#04110d",
    backgroundColor: "#28c99a",
    fontSize: 9,
    fontWeight: "900",
  } as never,
  playbackCacheDiagnosticsName: {
    color: "#d8eee7",
    fontFamily: "monospace",
  } as never,
  playbackCacheDiagnosticsEmpty: {
    padding: "14px 12px",
    borderTop: "1px solid #183b30",
    color: "#678279",
    fontSize: 11,
  } as never,
  interactionShareControlsHost: {
    flexShrink: 0,
    minHeight: 36,
    display: "flex",
    alignItems: "center",
  } as never,
  favoriteButton: {
    height: 36,
    paddingHorizontal: 13,
    borderRadius: 18,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    borderWidth: 1,
    borderColor: "#80643b",
    backgroundColor: "#211b13",
  },
  favoriteButtonActive: { backgroundColor: "#d7a955", borderColor: "#f0ca82" },
  favoriteText: { color: "#f0ca82", fontSize: 13, fontWeight: "800" },
  favoriteTextActive: { color: "#17120b" },
  subscriptionButton: {
    height: 36,
    paddingHorizontal: 13,
    borderRadius: 18,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    borderWidth: 1,
    borderColor: "#2f765f",
    backgroundColor: "#0a211a",
  },
  subscriptionButtonActive: {
    borderColor: "#28c99a",
    backgroundColor: "#126b51",
  },
  subscriptionButtonDisabled: { opacity: 0.5 },
  subscriptionButtonText: {
    fontFamily: MISANS,
    color: "#bdeee0",
    fontSize: 13,
    fontWeight: "600",
  },
  subscriptionButtonTextActive: { color: "#f2f5f4" },
  commentCount: {
    fontFamily: INTER,
    color: "#f2f5f4",
    fontSize: 13,
    fontWeight: "600",
  },
  videoTags: {
    flex: 1,
    minWidth: 0,
    color: "#d7b65d",
    fontSize: 12,
  },
  commentComposer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginTop: 12,
  },
  commentInput: {
    flex: 1,
    height: 40,
    borderWidth: 1,
    borderColor: "#285848",
    borderRadius: 8,
    paddingHorizontal: 12,
    color: "#f5efe5",
    backgroundColor: "#040b09",
    outlineStyle: "none",
  } as never,
  commentSubmit: {
    height: 40,
    paddingHorizontal: 15,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#d7b65d",
  },
  commentSubmitText: { color: "#17120b", fontSize: 13, fontWeight: "800" },
  interactionError: { color: "#ff9c9c", fontSize: 12, marginTop: 8 },
  commentRow: {
    flexDirection: "row",
    gap: 10,
    marginTop: 10,
    paddingTop: 9,
    borderTopWidth: 1,
    borderTopColor: "#292929",
  },
  commentAuthor: {
    width: 90,
    color: "#d7a955",
    fontSize: 12,
    fontWeight: "700",
  },
  commentBody: { flex: 1, color: "#d7d7d7", fontSize: 13 },
  adminToolbar: {
    marginTop: 12,
    padding: 8,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#2f765f",
    backgroundColor: "#0a211a",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
  },
  adminToolbarBadge: {
    height: 30,
    paddingHorizontal: 10,
    borderRadius: 15,
    backgroundColor: "#37d5aa",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  adminToolbarBadgeText: { color: "#07130f", fontSize: 12, fontWeight: "900" },
  adminToolbarButton: {
    height: 30,
    paddingHorizontal: 10,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#357662",
    backgroundColor: "#102e25",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  adminToolbarButtonText: { color: "#bdeee0", fontSize: 12, fontWeight: "700" },
  adminToolbarDangerButton: {
    height: 30,
    paddingHorizontal: 10,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#864545",
    backgroundColor: "#321717",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  adminToolbarDangerText: { color: "#ffb0b0", fontSize: 12, fontWeight: "700" },
  adminToolbarCriticalButton: {
    height: 30,
    paddingHorizontal: 10,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#ff6868",
    backgroundColor: "#a52222",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  adminToolbarCriticalText: { color: "#fff", fontSize: 12, fontWeight: "900" },
  adminEditorBackdrop: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    backgroundColor: "rgba(0, 0, 0, 0.78)",
  },
  adminEditorCard: {
    width: "min(820px, 94vw)" as never,
    maxHeight: "88vh" as never,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#2f765f",
    backgroundColor: "#07130f",
    overflow: "hidden",
  },
  adminEditorHeader: {
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#204b3d",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  adminEditorTitle: { color: "#f2f5f4", fontSize: 19, fontWeight: "800" },
  adminEditorHint: { marginTop: 4, color: "#82b4a5", fontSize: 12 },
  adminEditorClose: {
    width: 36,
    height: 36,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: "#2f765f",
    alignItems: "center",
    justifyContent: "center",
  },
  adminEditorScroll: { maxHeight: "68vh" as never },
  adminEditorBody: { padding: 20, gap: 8 },
  adminEditorLabel: { color: "#a9d9cb", fontSize: 12, fontWeight: "700", marginTop: 4 },
  adminEditorInput: {
    minHeight: 40,
    borderWidth: 1,
    borderColor: "#285848",
    borderRadius: 8,
    paddingHorizontal: 11,
    color: "#f5efe5",
    backgroundColor: "#040b09",
    outlineStyle: "none",
  } as never,
  adminVariantHeading: {
    marginTop: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  adminSmallButton: {
    height: 30,
    paddingHorizontal: 10,
    borderRadius: 7,
    backgroundColor: "#37d5aa",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
  },
  adminSmallButtonText: { color: "#07130f", fontSize: 12, fontWeight: "800" },
  adminVariantCard: {
    marginTop: 8,
    padding: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#204b3d",
    backgroundColor: "#0a1b16",
    gap: 7,
  },
  adminVariantTopRow: { flexDirection: "row", alignItems: "center", justifyContent: "space-between" },
  adminVariantKind: { color: "#56dcb6", fontSize: 12, fontWeight: "800" },
  adminDangerLink: { flexDirection: "row", alignItems: "center", gap: 5, padding: 4 },
  adminDangerLinkText: { color: "#ff9c9c", fontSize: 12, fontWeight: "700" },
  adminEditorError: { color: "#ff9c9c", fontSize: 12, marginTop: 8 },
  adminEditorFooter: {
    paddingHorizontal: 20,
    paddingVertical: 14,
    borderTopWidth: 1,
    borderTopColor: "#204b3d",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
  },
  adminSecondaryButton: {
    height: 38,
    paddingHorizontal: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#3e6b5d",
    alignItems: "center",
    justifyContent: "center",
  },
  adminSecondaryButtonText: { color: "#bdeee0", fontSize: 13, fontWeight: "700" },
  adminPrimaryButton: {
    height: 38,
    paddingHorizontal: 18,
    borderRadius: 8,
    backgroundColor: "#37d5aa",
    alignItems: "center",
    justifyContent: "center",
  },
  adminPrimaryButtonText: { color: "#07130f", fontSize: 13, fontWeight: "900" },
  adminCommentInput: {
    flex: 1,
    minHeight: 34,
    borderWidth: 1,
    borderColor: "#357662",
    borderRadius: 7,
    paddingHorizontal: 9,
    color: "#f5efe5",
    backgroundColor: "#040b09",
    outlineStyle: "none",
  } as never,
  adminCommentActions: { flexDirection: "row", alignItems: "center", gap: 6 },
  adminCommentAction: { flexDirection: "row", alignItems: "center", gap: 4, padding: 5 },
  adminCommentActionText: { color: "#8ee4ca", fontSize: 12, fontWeight: "700" },
  adminCommentDangerText: { color: "#ff9c9c", fontSize: 12, fontWeight: "700" },
  cacheSettingsCard: {
    width: "min(720px, 92vw)" as never,
    maxHeight: "86vh" as never,
    backgroundColor: "white",
    borderRadius: 14,
    overflow: "hidden",
  },
  cacheSettingsHeader: {
    minHeight: 68,
    paddingHorizontal: 20,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#e7e7e7",
  },
  cacheSettingsTitle: { color: "#171717", fontSize: 18, fontWeight: "800" },
  cacheSettingsSubtitle: { color: "#777", fontSize: 12, marginTop: 4 },
  cacheSettingsClose: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f2f2f2",
  },
});
